var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatasetsLight = function SvgDatasetsLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 78,
    fill: "none",
    viewBox: "0 0 70 78"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#datasets-light_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.594 15.945v10.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.855.436 1.976.436 4.216.436h9.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#datasets-light_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.594 55.945v-10.6c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h9.6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#datasets-light_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M50.594 15.945v10.6c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-9.6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#datasets-light_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M50.594 55.945v-10.6c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436h-9.6"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 37.188,
    height: 37.188,
    x: 32,
    y: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#datasets-light_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#datasets-light_svg__f)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets-light_svg__g)",
    fillOpacity: 0.2,
    d: "M42.594 14.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets-light_svg__h)",
    d: "M42.594 14.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeOpacity: 0.05,
    d: "M48.994 8.445h3.2c1.128 0 1.944 0 2.586.053.636.052 1.057.153 1.403.33a3.5 3.5 0 0 1 1.529 1.528c.176.346.277.767.329 1.403.053.642.053 1.458.053 2.587v3.199c0 1.128 0 1.945-.053 2.587-.052.636-.153 1.057-.33 1.402a3.5 3.5 0 0 1-1.528 1.53c-.346.176-.767.277-1.403.329-.642.052-1.458.052-2.587.052h-3.199c-1.128 0-1.945 0-2.587-.052-.636-.052-1.056-.153-1.402-.33a3.5 3.5 0 0 1-1.53-1.529c-.175-.345-.276-.766-.328-1.402-.053-.642-.053-1.459-.053-2.587v-3.2c0-1.128 0-1.944.053-2.586.052-.636.153-1.057.329-1.403a3.5 3.5 0 0 1 1.529-1.529c.345-.176.766-.277 1.402-.329.642-.052 1.459-.053 2.587-.053Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 37.188,
    height: 37.188,
    x: 16,
    y: 20
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#datasets-light_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#datasets-light_svg__j)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets-light_svg__k)",
    d: "M26.594 34.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.375,
    d: "M32.994 28.133h3.2c1.122 0 1.954 0 2.612.053.655.054 1.121.16 1.518.363.718.365 1.3.948 1.666 1.666.203.397.309.863.362 1.518.054.658.054 1.49.054 2.613v3.199c0 1.123 0 1.955-.053 2.612-.054.656-.16 1.122-.363 1.519a3.8 3.8 0 0 1-1.666 1.666c-.397.202-.863.309-1.518.362-.658.054-1.49.054-2.613.054h-3.199c-1.123 0-1.955 0-2.612-.054-.655-.053-1.122-.16-1.519-.362a3.8 3.8 0 0 1-1.666-1.666c-.202-.397-.308-.863-.362-1.519-.054-.657-.054-1.489-.054-2.612v-3.2c0-1.123 0-1.954.054-2.612.053-.655.16-1.121.362-1.518.366-.718.949-1.3 1.666-1.666.397-.202.864-.309 1.519-.363.657-.053 1.489-.053 2.612-.053Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 37.188,
    height: 37.188,
    x: 32,
    y: 40
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#datasets-light_svg__l)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#datasets-light_svg__m)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets-light_svg__n)",
    fillOpacity: 0.5,
    d: "M42.594 54.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets-light_svg__o)",
    fillOpacity: 0.25,
    d: "M42.594 54.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M48.994 48.445h3.2c1.128 0 1.944 0 2.586.053.636.052 1.057.153 1.403.33a3.5 3.5 0 0 1 1.529 1.528c.176.346.277.767.329 1.403.053.642.053 1.458.053 2.587v3.199c0 1.128 0 1.945-.053 2.587-.052.636-.153 1.057-.33 1.402a3.5 3.5 0 0 1-1.528 1.53c-.346.176-.767.277-1.403.329-.642.052-1.458.052-2.587.052h-3.199c-1.128 0-1.945 0-2.587-.052-.636-.052-1.056-.153-1.402-.33a3.5 3.5 0 0 1-1.53-1.529c-.175-.345-.276-.766-.328-1.402-.053-.642-.053-1.459-.053-2.587v-3.2c0-1.128 0-1.944.053-2.586.052-.636.153-1.057.329-1.403a3.5 3.5 0 0 1 1.529-1.529c.345-.176.766-.277 1.402-.329.642-.052 1.459-.053 2.587-.053Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 37.188,
    height: 37.188,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#datasets-light_svg__p)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#datasets-light_svg__q)",
    shapeRendering: "crispEdges"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets-light_svg__r)",
    fillOpacity: 0.5,
    d: "M10.594 14.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets-light_svg__s)",
    fillOpacity: 0.25,
    d: "M10.594 14.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M16.994 8.445h3.2c1.128 0 1.944 0 2.586.053.636.052 1.057.153 1.403.33a3.5 3.5 0 0 1 1.529 1.528c.176.346.277.767.329 1.403.052.642.053 1.458.053 2.587v3.199c0 1.128 0 1.945-.053 2.587-.052.636-.153 1.057-.33 1.402a3.5 3.5 0 0 1-1.528 1.53c-.346.176-.767.277-1.403.329-.642.052-1.458.052-2.587.052h-3.199c-1.128 0-1.945 0-2.587-.052-.636-.052-1.056-.153-1.402-.33a3.5 3.5 0 0 1-1.53-1.529c-.175-.345-.277-.766-.328-1.402-.053-.642-.053-1.459-.053-2.587v-3.2c0-1.128 0-1.944.053-2.586.051-.636.152-1.057.329-1.403a3.5 3.5 0 0 1 1.529-1.529c.345-.176.766-.277 1.402-.329.642-.052 1.459-.053 2.587-.053Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 37.188,
    height: 37.188,
    x: 0,
    y: 40
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#datasets-light_svg__t)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#datasets-light_svg__u)",
    shapeRendering: "crispEdges"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets-light_svg__v)",
    fillOpacity: 0.2,
    d: "M10.594 54.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets-light_svg__w)",
    d: "M10.594 54.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeOpacity: 0.05,
    d: "M16.994 48.445h3.2c1.128 0 1.944 0 2.586.053.636.052 1.057.153 1.403.33a3.5 3.5 0 0 1 1.529 1.528c.176.346.277.767.329 1.403.052.642.053 1.458.053 2.587v3.199c0 1.128 0 1.945-.053 2.587-.052.636-.153 1.057-.33 1.402a3.5 3.5 0 0 1-1.528 1.53c-.346.176-.767.277-1.403.329-.642.052-1.458.052-2.587.052h-3.199c-1.128 0-1.945 0-2.587-.052-.636-.052-1.056-.153-1.402-.33a3.5 3.5 0 0 1-1.53-1.529c-.175-.345-.277-.766-.328-1.402-.053-.642-.053-1.459-.053-2.587v-3.2c0-1.128 0-1.944.053-2.586.051-.636.152-1.057.329-1.403a3.5 3.5 0 0 1 1.529-1.529c.345-.176.766-.277 1.402-.329.642-.052 1.459-.053 2.587-.053Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "datasets-light_svg__a",
    width: 20,
    height: 21,
    x: 16.594,
    y: 14.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26720",
    result: "effect2_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets-light_svg__b",
    width: 20,
    height: 21,
    x: 16.594,
    y: 37.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26720",
    result: "effect2_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets-light_svg__c",
    width: 20,
    height: 21,
    x: 32.594,
    y: 14.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26720",
    result: "effect2_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets-light_svg__d",
    width: 20,
    height: 21,
    x: 32.594,
    y: 37.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26720",
    result: "effect2_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets-light_svg__f",
    width: 37.188,
    height: 37.188,
    x: 32,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets-light_svg__j",
    width: 37.188,
    height: 37.188,
    x: 16,
    y: 20,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets-light_svg__m",
    width: 37.188,
    height: 37.188,
    x: 32,
    y: 40,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets-light_svg__q",
    width: 37.188,
    height: 37.188,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets-light_svg__u",
    width: 37.188,
    height: 37.188,
    x: 0,
    y: 40,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets-light_svg__g",
    x1: 50.594,
    x2: 50.594,
    y1: 15.045,
    y2: 23.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets-light_svg__k",
    x1: 35.094,
    x2: 35.094,
    y1: 28.181,
    y2: 54.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets-light_svg__n",
    x1: 50.594,
    x2: 50.594,
    y1: 55.045,
    y2: 63.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets-light_svg__r",
    x1: 18.594,
    x2: 18.594,
    y1: 15.045,
    y2: 23.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets-light_svg__v",
    x1: 18.594,
    x2: 18.594,
    y1: 55.045,
    y2: 63.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets-light_svg__e",
    transform: "translate(-32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.594 14.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets-light_svg__i",
    transform: "translate(-16 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.594 34.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets-light_svg__l",
    transform: "translate(-32 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.594 54.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets-light_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.594 14.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets-light_svg__t",
    transform: "translate(0 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.594 54.345c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.855-.436 1.976-.436 4.216-.436h3.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-3.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.855-.436-1.976-.436-4.216z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "datasets-light_svg__h",
    width: 4,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#datasets-light_svg__x",
    transform: "scale(.0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "datasets-light_svg__o",
    width: 4,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#datasets-light_svg__x",
    transform: "scale(.0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "datasets-light_svg__s",
    width: 4,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#datasets-light_svg__x",
    transform: "scale(.0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "datasets-light_svg__w",
    width: 4,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#datasets-light_svg__x",
    transform: "scale(.0039)"
  })))));
};
export default SvgDatasetsLight;